import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
import { openCalendlyPopup } from '../utils/calendly';
export function StorySection() {
  return <section className="py-20 bg-[#0A0E27] relative" data-id="element-171" data-mp="c1l595ke9g6q">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172" data-mp="c24l8gqhhui4">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-173" data-mp="80jb335c3ubm">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-174" data-mp="7y6lq4x8yhoj">
            Why I Do <span className="text-[#FF5722]" data-id="element-175" data-mp="14ph7sqwna2bf">This Work</span>
          </h2>
          <div className="h-1 w-20 bg-[#FF5722] mx-auto rounded-full" data-id="element-176" data-mp="zsh3oljcv9my"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-177" data-mp="voj4ybxy00uf">
          <div className="space-y-6 text-lg text-[#94A3B8] leading-relaxed" data-id="element-178" data-mp="qr0tadsjj7iq">
            <p data-id="element-179" data-mp="3gftau4lr4ng8">
              <strong className="text-white" data-id="element-180" data-mp="3ggci8rdrztg0">
                "We automate everything except the fun."
              </strong>
            </p>
            <p data-id="element-181" data-mp="3bf5bmvndd0ax">
              I come from two worlds: IT and sales. This combination is rare –
              and that's what makes the crucial difference.
            </p>
            <p data-id="element-182" data-mp="1t714lrvbi7el">
              As a developer, I understand the technical requirements for a
              robust system. As a salesperson, I know the daily struggle for
              leads, the frustration of manual data entry, and the pressure of
              quarterly targets.
            </p>
            <p data-id="element-183" data-mp="15gyc5anhqzfg">
              Many CRM systems are built in ivory towers. Mine are forged in
              practice. Every feature exists because it solves a real problem
              that I or my team have experienced firsthand.
            </p>

            <div className="pt-6 flex flex-col sm:flex-row gap-4" data-id="element-184" data-mp="wefct0iwz4xy">
              <Button variant="outline" rightIcon={<ArrowRight className="w-4 h-4" data-id="element-186" data-mp="mhssccui2fwg" />} onClick={openCalendlyPopup} data-id="element-185" data-mp="10iwvewdjfc75">
                Book Free Demo
              </Button>
            </div>
          </div>

          <div className="relative" data-id="element-187" data-mp="2t6cqlso0o6y0">
            <div className="absolute inset-0 bg-gradient-to-r from-[#FF5722]/20 to-[#3B82F6]/20 blur-3xl rounded-full opacity-30" data-id="element-188" data-mp="2t7ebeouu47sx"></div>
            <div className="relative bg-[#141B3A] border border-[#1E293B] rounded-2xl p-8 md:p-12" data-id="element-189" data-mp="2oe1medm8tyzn">
              <blockquote className="text-xl md:text-2xl font-medium text-white italic mb-8" data-id="element-190" data-mp="2kbwubjbg1af4">
                "My goal wasn't another complicated tool, but a system that
                sales teams actually want to use because it takes work off their
                plate instead of creating more."
              </blockquote>
              <div className="flex items-center gap-4" data-id="element-191" data-mp="33497l13mxw41">
                <div className="w-12 h-12 rounded-full bg-[#FF5722] flex items-center justify-center text-white font-bold" data-id="element-192" data-mp="336vgp566cjod">
                  JK
                </div>
                <div data-id="element-193" data-mp="1rqevswbupau4">
                  <div className="font-bold text-white" data-id="element-194" data-mp="1rqx2kmw537ga">Justus Kraft</div>
                  <div className="text-sm text-[#94A3B8]" data-id="element-195" data-mp="1mphioy5p76zh">
                    CRM &amp; Sales Automation Expert
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}